import React from "react";
import styled from "styled-components";
import {Col, Select} from "antd";

export const Img = styled.img`
    height: 80px;
    display: flex;
    margin: auto;
    border-radius: 4px;
    border: 10px solid #fafafa;
    box-sizing: content-box;
`;
export const IconCol = styled(({hasError, ...props}) => <Col {...props} />)`
    margin: auto 0;
    color: #ffffff;
    font-size: 20px;
    background: ${props => (props.hasError ? "#ff4d4f" : "#009688")};
    border-radius: 50%;
    padding: ${props => (props.hasError ? "5px 7px 5px 7px" : "5px")};
    margin-right: 10px;
`;

export const SelectField = styled(Select)`
    .ant-select-selection-item {
        height: auto !important;
    }
    .abcx {
        background-color: red;
    }
`;
